module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('img', {
    staticClass: "ma-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/img/start.jpg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md8": "",
      "lg9": "",
      "text-xs-left": ""
    }
  }, [_c('div', {
    staticClass: "ma-2"
  }, [_c('h1', [_vm._v("Willkommen " + _vm._s(_vm.$appData.account.username))]), _vm._v(" zu Ihrem persönlichen Online-Kundenservice\n      ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€\n        ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52da6c88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Dashboard.vue
// module id = 587
// module chunks = 1